// extracted by mini-css-extract-plugin
export var measureBox = "_cl-0";